
import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';
import Grid from 'components/core/Grid';
import { Box, Typography } from '@mui/material';
import { FullBooking, type Offer } from '@alluradirect/react';

import { BookingCheckoutResponse } from 'components/views/pages/Checkout/hooks/useCheckout';
import { getOfferValueDisplay } from 'components/views/pages/Checkout/hooks/useOfferQueries';
import { getOffersData } from 'components/views/pages/Checkout/CheckoutSummary/helpers';
import { LabelAndValue } from 'components/core/LabelAndValue/LabelAndValue';
import {
  getDatesDisplay,
  getBlackoutPeriodsDisplay
} from 'components/views/forms/PromotionOffers/helpers/fieldHelper';
import { SetupItem } from 'components/styles';

interface Props {
  isOpen: boolean;
  close: () => void;
  checkoutData: BookingCheckoutResponse | undefined;
  bookingData: FullBooking | undefined;
  isLastStep: boolean;
}

interface DemoProps {
  offerData: Offer;
}

const PromotionItem = ({ offerData }: DemoProps) => {
  if (!offerData) return null;

  const rentalDates = getDatesDisplay(offerData.OFFER_START, offerData.OFFER_END);
  const validDates = getDatesDisplay(offerData.OFFER_AVAILABLE_START, offerData.OFFER_AVAILABLE_END);
  const blackoutPeriods = getBlackoutPeriodsDisplay(offerData);

  return (
    <SetupItem item xs={12}>
      <Typography fontWeight={500}>
        {offerData.TITLE}
      </Typography>
      <Typography variant="body2" mb={1}>
        {offerData.DESCRIPTION}
      </Typography>
      <LabelAndValue label="Rental Dates" value={rentalDates} />
      <LabelAndValue label="Offer Valid Dates" value={validDates} />
      <Box mb={1}>
        <LabelAndValue label="Blackout Dates" value={blackoutPeriods} />
      </Box>
      <Typography fontWeight={500} variant="body2" style={{ color: 'green' }}>
        {getOfferValueDisplay(offerData)}
      </Typography>
    </SetupItem>
  );
};

export const CheckoutSummaryPromotionsDialog = ({ isOpen, close, checkoutData, bookingData, isLastStep }: Props) => {

  const { ownerOffer, alluraOffer, ownerGiftCertificate, alluraGiftCertificate } = getOffersData({ checkoutData, bookingData, isLastStep });

  return (
    <ConfirmationDialog
      isDialogOpen={isOpen}
      handleCloseDialog={close}
      hasBottomBar={false}
      dialogTitle="Promotions"
      useIsXs={false}
      maxWidth="xs"
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="body2">The following promotion offers have been applied...</Typography>
        </Grid>
        {ownerOffer && (
          <PromotionItem offerData={ownerOffer} />
        )}
        {alluraOffer && (
          <PromotionItem offerData={alluraOffer} />
        )}
        {ownerGiftCertificate && (
          <PromotionItem offerData={ownerGiftCertificate} />
        )}
        {alluraGiftCertificate && (
          <PromotionItem offerData={alluraGiftCertificate} />
        )}
      </Grid>
    </ConfirmationDialog>
  );
};
